import "@/config/mobx";
import React from "react";
import { createRoot } from "react-dom/client";
import "@/services/loadMomentLocale";
import { TOKEN_KEY } from "@/services/http/AuthTokenHolder";
import App from "./App";

// 性能检测
// if (process.env.NODE_ENV !== "production") {
//   const { whyDidYouUpdate } = require("why-did-you-update");
//   whyDidYouUpdate(React);
// }

// 同个浏览器下, 旧页面检测到token变化后刷新
window.addEventListener("storage", (storage) => {
    if (storage.key === TOKEN_KEY) {
        window.location.href = "/";
    }
});

createRoot(document.getElementById("root")!).render(<App />);
